import axios from "axios";
import swal from "sweetalert2";

import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { accessTokenKey, baseUrl } from "../utils/config";

import Loader from "./layouts/Loader";

function CVManager() {

    const [loading, setLoading] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [settingDefault, setSettingDefault] = useState(false);
    const [cvs, setCvs] = useState([]);

    async function fetch() {
        setLoading(true);

        try {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const formData = new FormData();
            formData.append("time_zone", timeZone);

            const response = await axios.post(
                baseUrl + "/api/cvs/fetch",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                setCvs(response.data.cvs);
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setLoading(false);
        }
    }

    async function uploadCV() {
        setUploading(true);

        try {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

            const form = document.getElementById("form-upload-cv");
            const formData = new FormData(form);
            formData.append("time_zone", timeZone);

            const isDefault = document.querySelector(".is_default").checked;
            formData.append("is_default", isDefault ? 1 : 0);

            const response = await axios.post(
                baseUrl + "/api/cvs/upload",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                const cv = response.data.cv;
                const temp = [ ...cvs ];

                if (isDefault == 1) {
                    for (let a = 0; a < temp.length; a++) {
                        temp[a].is_default = 0;
                    }
                }

                temp.unshift(cv);
                setCvs(temp);

                swal.fire("Upload", response.data.message, "success");
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setUploading(false);
        }
    }

    async function setAsDefault(id) {
        setSettingDefault(true);

        try {
            const formData = new FormData();
            formData.append("id", id);

            const response = await axios.post(
                baseUrl + "/api/cvs/set-default",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                const temp = [ ...cvs ];
                for (let a = 0; a < temp.length; a++) {
                    temp[a].is_default = (temp[a].id == id ? 1 : 0);
                }
                setCvs(temp);
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setSettingDefault(false);
        }
    }

    async function deleteCV(id, title, node) {
        swal.fire({
            title: "Delete CV: '" + title + "'",
            text: "All your applications on this CV will be removed ?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then(async function (result) {
            if (result.isConfirmed) {
                try {
                    const formData = new FormData()
                    formData.append("id", id)

                    const response = await axios.post(
                        baseUrl + "/api/cvs/delete",
                        formData,
                        {
                            headers: {
                                Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                            }
                        }
                    );

                    if (response.data.status == "success") {
                        const temp = [...cvs]
                        for (let a = 0; a < temp.length; a++) {
                            if (temp[a].id == id) {
                                temp.splice(a, 1)
                            }
                        }
                        setCvs(temp)
                    } else {
                        swal.fire("Error", response.data.message, "error")
                    }
                } catch (exp) {
                    swal.fire("Error", exp.message, "error")
                }
            }
        });
    }

    useEffect(function () {
        fetch();
    }, []);

    const styles = {
        bgWhite: {
            backgroundColor: "white"
        },
        labelDefault: {
            position: "relative",
            top: "15px"
        }
    };

    return (
        <>
            <div className="container-xxl py-5 bg-dark page-header mb-5">
                <div className="container my-5 pt-5 pb-4">
                    <h1 className="display-3 text-white mb-3 animated slideInDown">CV Manager</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb text-uppercase">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item text-white active" aria-current="page">CV Manager</li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div className="container-xxl py-5">
                <div className="container">

                    <form onSubmit={ function (event) {
                        event.preventDefault();
                        uploadCV();
                    } } id="form-upload-cv"
                        encType="multipart/form-data">

                        <div className="row g-3 mb-5">
                            <div className="offset-md-1 col-md-3">
                                <div className="form-floating">
                                    <input type="file" accept="application/pdf" className="form-control" name="file"
                                        style={ styles.bgWhite }
                                        required />
                                    <label>Upload CV</label>
                                </div>
                            </div>

                            <div className="col-md-3">
                                <div className="form-floating">
                                    <input type="text" className="form-control" name="title" required />
                                    <label>Title</label>
                                </div>
                            </div>

                            <div className="col-md-2">
                                <label style={ styles.labelDefault }>
                                    Set as Default ?&nbsp;
                                    <input type="checkbox" className="is_default" />
                                </label>
                            </div>

                            <div className="col-md-3">
                                <div className="form-floating">
                                    <input type="submit" className="btn btn-primary" value="Upload"
                                    disabled={ uploading } />
                                </div>
                            </div>
                        </div>
                    </form>

                    <h1 className="text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">My CVs</h1>
                    
                    <div className="row">
                        <div className="col-md-12">

                            <table className="table table-bordered table-responsive">
                                <thead>
                                    <tr>
                                        <th>Title</th>
                                        <th>Default ?</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    { cvs.map(function (cv) {
                                        return (
                                            <tr key={ `cv-${ cv.id }` }>
                                                <td>
                                                    <a href={ cv.path }
                                                        target="_blank">{ cv.title }</a>
                                                </td>

                                                <td>{ cv.is_default ? "Yes" : "No" }</td>

                                                <td>
                                                    { !cv.is_default  && (
                                                        <button type="button"
                                                            className="btn btn-primary"
                                                            onClick={ function (event) {
                                                                setAsDefault(cv.id);
                                                            } }
                                                            disabled={ settingDefault }>Set as Default</button>
                                                    ) }

                                                    &nbsp;<button type="button"
                                                        className="btn btn-danger"
                                                        onClick={ function (event) {
                                                            deleteCV(cv.id, cv.title, event.target);
                                                        } }>Delete</button>
                                                </td>
                                            </tr>
                                        );
                                    }) }
                                </tbody>
                            </table>

                            { loading && (
                                <div className="text-center mt-3">
                                    <Loader />
                                </div>
                            ) }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CVManager;